import React, { FC } from 'react'
import { ClbButton } from '@celebration/react'
import { Container, Icon, Title, Description } from './styles/Warning.styles'
import { Icons } from '@celebration/react/ClbIcon/props.types'

type WarningProps = {
  icon: Icons
  title: string
  description: string
  label: string
  ariaLabel: string
  onResolve: () => void
}

const Warning: FC<WarningProps> = ({
  icon,
  title,
  description,
  label,
  ariaLabel,
  onResolve,
}): React.ReactElement => {
  return (
    <Container>
      <Icon size='lg' icon={icon} type='neutral' />
      <Title size='sm' type='h1'>
        {title}
      </Title>
      <Description size='md' color='neutral' weight='400'>
        {description}
      </Description>
      <ClbButton
        type='button'
        styleType='primary'
        size='sm'
        onClick={onResolve}
        label={label}
        aria-label={ariaLabel}
      />
    </Container>
  )
}

export default Warning
